import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };

const Field = ({ label, value, onChange, testid }) => (
  <div className="space-y-1.5">
    <Label>{label}</Label>
    <Input type="password" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} autoComplete="new-password" />
  </div>
);

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 8) { setError("La nueva contraseña debe tener al menos 8 caracteres"); return; }
    if (f.next !== f.confirm) { setError("Las contraseñas nuevas no coinciden"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Contraseña actualizada. Se cerraron tus otras sesiones.");
      setOpen(false); setF(EMPTY);
    } catch (err) { setError(apiError(err).message); }
    finally { setSaving(false); }
  };

  return (
    <>
      <button data-testid="sidebar-change-password-button" onClick={() => setOpen(true)}
        className="mt-1 flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-300 transition-colors hover:bg-white/5 hover:text-white">
        <KeyRound size={16} /> Cambiar contraseña
      </button>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) { setF(EMPTY); setError(""); } }}>
        <DialogContent className="admin-shell sm:max-w-md" data-testid="change-password-dialog">
          <DialogHeader>
            <DialogTitle>Cambiar contraseña</DialogTitle>
            <DialogDescription>Al guardar se cerrará tu sesión en otros dispositivos.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <Field label="Contraseña actual" value={f.current} onChange={set("current")} testid="change-password-current" />
            <Field label="Nueva contraseña (mínimo 8 caracteres)" value={f.next} onChange={set("next")} testid="change-password-new" />
            <Field label="Confirmar nueva contraseña" value={f.confirm} onChange={set("confirm")} testid="change-password-confirm" />
            {error && <p className="text-sm text-rose-600" data-testid="change-password-error">{error}</p>}
            <Button type="submit" disabled={saving || !f.current} className="w-full bg-[#2F5BFF] hover:bg-[#1F45E0]" data-testid="change-password-submit">
              {saving ? "Guardando…" : "Guardar contraseña"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
